import AttachedCloudIntegrationsSection from "components/AttachCloud/Details/CloudIntegrationsSection";
import Box from "ds/components/Box";
import useTypedContext from "hooks/useTypedContext";
import { CLOUD_INTEGRATION_CONFIG } from "shared/CloudIntegration/constants";

import useAttachedCloudIntegration from "../AttachCloud/hooks/useAttachedCloudIntegration";
import { StackFormContext } from "../context";
import { StackCreationWizardStep } from "../types";
import NewStackSummaryPanel from "./Panel";

type NewStackSummaryCloudProps = {
  title: string;
  goToStepDisabled?: boolean;
};

const cloudConfig = [
  CLOUD_INTEGRATION_CONFIG.AWS,
  CLOUD_INTEGRATION_CONFIG.Azure,
  CLOUD_INTEGRATION_CONFIG.GCP,
];

const NewStackSummaryCloud = ({ title, goToStepDisabled }: NewStackSummaryCloudProps) => {
  const { formData, createdStackId } = useTypedContext(StackFormContext);
  const stackLabels = formData[StackCreationWizardStep.Details].labels;
  const { manuallyAttachedIntegrations, autoAttachedIntegrations, loading, hasData, refetch } =
    useAttachedCloudIntegration();

  return (
    <NewStackSummaryPanel
      name={title}
      step={StackCreationWizardStep.Cloud}
      goToStepDisabled={goToStepDisabled}
      fullbleed
    >
      {!loading && hasData && (
        <Box direction="column" gap="x-large">
          <AttachedCloudIntegrationsSection
            title="Attached directly"
            integrations={manuallyAttachedIntegrations}
            cloudConfig={cloudConfig}
            stackId={createdStackId}
            readOnly={false}
            onSuccessDetach={refetch}
            stackLabels={stackLabels.map((label) => label.value)}
          />
          <AttachedCloudIntegrationsSection
            title="Auto-attached"
            integrations={autoAttachedIntegrations}
            cloudConfig={cloudConfig}
            stackId={createdStackId}
            readOnly={true}
            isAutoAttached={true}
            stackLabels={stackLabels.map((label) => label.value)}
          />
        </Box>
      )}
    </NewStackSummaryPanel>
  );
};

export default NewStackSummaryCloud;
